import styled from 'styled-components';
import { baseTheme } from '../../global/styles/theme';

export const BlockedProductModalContainer = styled('div')`
  color: ${baseTheme.colors.secondary};
  width: 360px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  div {
    display: flex;
    justify-content: center;
  }

  .products-title {
    display: flex;
    justify-content: flex-start;
    font-size: 24px;
    font-weight: 700;
    color: ${baseTheme.colors.primary};
  }

  .products-sub-title {
    line-height: 22px;
  }

  .products-code-select {
    background: none;
    border: none;
    color: ${baseTheme.colors.mainLightBlue};
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    padding: 10px 20px;
    border-radius: 5px;
    border: 1px solid ${baseTheme.colors.mainLightBlue};
  }

  .reason-input {
    display: flex;
    flex-direction: column;
  }
`;

export const ModalButtonsContainer = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 54px;

  .save-btn,
  .cancel-btn {
    display: block;
  }
`;
